/**
 * Component which displays login codes for a school.
 *
 * Bindings:
 *
 * dbl-district-id - ID of district
 * dbl-school-id   - ID of school
 * dbl-on-ready    - Expression to evaluate when data finishes loading.
 *
 * The dbl-on-ready binding exists for printing the component since printing can't be trigger until after all data is loaded.
 */
(function(){
  angular.module('charts')
    .component('edxClassroomCodeReport', {
      templateUrl: '/resources/charts/directives/classroom-code-print/classroom-code-report.component.html',
      controller: ['schoolApi', 'dblProductResourcesService', '$timeout', ClassroomCodeReport],
      controllerAs: 'vm',
      bindings: {
        districtId: '<dblDistrictId',
        schoolId: '<dblSchoolId',
        onReadyCb: '&dblOnReady'
      }
    });

  function ClassroomCodeReport(schoolApi, dblProductResourcesService, $timeout) {
    var vm = this;

    // Track outstanding load operations
    vm.loading = 0;

    // School level information
    vm.school = {};

    // Classroom information
    vm.classrooms = [];

    vm.$onInit = function() {
      vm.loading ++;
      schoolApi.getSchool(vm.schoolId, function (school) {
        vm.school = school;
        vm.loginUrl = dblProductResourcesService.getStudentLoginUrl(
          school.district_url_identifier,
          school.url_identifier
        );
        vm.schoolCode = dblProductResourcesService.getSchoolCode(
          school.district_url_identifier,
          school.url_identifier
        );
      }).$promise.finally(function() {
        vm.loading --;
        _checkLoading();
      });

      vm.loading ++;
      schoolApi.getClassroomTeachers(vm.districtId, vm.schoolId)
        .then(function (classrooms) {
          vm.classrooms = classrooms.data.classrooms;
        }).finally(function() {
          vm.loading --;
          _checkLoading();
        });
    };

    /**
     * Concatenate the names of all the teachers for a classroom.
     * @param classroom
     * @return {string}
     */
    vm.teacherNames = function(classroom) {
      return _.map(classroom.teachers, function(teacher) {
        return teacher.first_name + ' ' + teacher.last_name;
      }).join(', ');
    };

    /**
     * Check to see if all load operations have finished can invoke callback if they are finished.
     * @private
     */
    function _checkLoading() {
      if (vm.loading === 0 && vm.onReadyCb) {
        vm.onReadyCb();
      }
    }
  }
})();
